import script from "./DocumentReviewPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentReviewPanel.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentReviewPanel.vue?vue&type=style&index=0&id=57b7ac84&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57b7ac84"]])

export default __exports__